<template>
    <div>
        <el-input
        placeholder="输入用户名回车搜索"
        v-model="input"
        style="width: 190px;"
        prefix-icon="el-icon-search"
        clearable
        @keyup.native.enter="ClickMeToSearch()">
        </el-input>
        <table v-loading="loading" class="table" style="margin-top:10px; border: 1px solid #F0F0F0">
            <thead>
                <tr>
                    <th scope="col" width="10%" class="header">名次</th>
                    <th scope="col" width="10%" class="header">参赛者</th>
                    <th scope="col" width="10%" class="header">通过</th>
                    <th scope="col" width="10%" class="header">罚时</th>
                    <th scope="col" width="10%" class="header">A</th>
                    <th scope="col" width="10%" class="header">B</th>
                    <th scope="col" width="10%" class="header">C</th>
                    <th scope="col" width="10%" class="header">D</th>
                    <th scope="col" width="10%" class="header">E</th>
                    <th scope="col" width="10%" class="header">F</th>
                </tr>
                <tr class="hover" v-show="user.order !== 0 && user.order !== null && user.order !== undefined">
                    <th class="body" scope="row">{{ user.order }}</th>
                    <td class="body" style="color:#25BBA6;">{{ itemm.user }}</td> 
                    <td class="body">{{ itemm.accept }}</td>
                    <td class="body" style="border-right: 1px solid lightgrey;">{{ parseInt(itemm.score / 60) }}</td>
                    <td v-if="itemm.attempt1 !== 0 && itemm.problem1 !== '-'" class="body" style="background-color: #EFF9F7; line-height: ;">
                        <div style="height: 16.9px; line-height: 16.9px;"> {{ itemm.problem1 }}</div>
                        <div style="height: 16.9px; line-height: 16.9px;">(-{{ itemm.attempt1 }})</div>
                    </td>
                    <td v-else-if="itemm.attempt1 === 0 && itemm.problem1 !== '-'" class="body" style="background-color: #BFE6DE; line-height: ;">
                        {{ itemm.problem1 }}
                    </td>
                    <td v-else-if="itemm.attempt1 !== 0 && itemm.problem1 === '-'" class="body" style="background-color: #FFECEC; line-height: ;">
                        (-{{ itemm.attempt1 }})
                    </td>
                    <td v-else class="body" style="background-color: #F4F4F4; line-height: ;">
                        {{ itemm.problem1 }}
                    </td>
                    <!-- 2 -->
                    <td v-if="itemm.attempt2 !== 0 && itemm.problem2 !== '-'" class="body" style="background-color: #EFF9F7; line-height: ;">
                        <div style="height: 16.9px; line-height: 16.9px;"> {{ itemm.problem2 }}</div>
                        <div style="height: 16.9px; line-height: 16.9px;">(-{{ itemm.attempt2 }})</div>
                    </td>
                    <td v-else-if="itemm.attempt2 === 0 && itemm.problem2 !== '-'" class="body" style="background-color: #BFE6DE; line-height: ;">
                        {{ itemm.problem2 }}
                    </td>
                    <td v-else-if="itemm.attempt2 !== 0 && itemm.problem2 === '-'" class="body" style="background-color: #FFECEC; line-height: ;">
                        (-{{ itemm.attempt2 }})
                    </td>
                    <td v-else class="body" style="background-color: #F4F4F4; line-height: ;">
                        {{ itemm.problem2 }}
                    </td>
                    <!-- 3 -->
                    <td v-if="itemm.attempt3 !== 0 && itemm.problem3 !== '-'" class="body" style="background-color: #EFF9F7; line-height: ;">
                        <div style="height: 16.9px; line-height: 16.9px;"> {{ itemm.problem3 }}</div>
                        <div style="height: 16.9px; line-height: 16.9px;">(-{{ itemm.attempt3 }})</div>
                    </td>
                    <td v-else-if="itemm.attempt3 === 0 && itemm.problem3 !== '-'" class="body" style="background-color: #BFE6DE; line-height: ;">
                        {{ itemm.problem3 }}
                    </td>
                    <td v-else-if="itemm.attempt3 !== 0 && itemm.problem3 === '-'" class="body" style="background-color: #FFECEC; line-height: ;">
                        (-{{ itemm.attempt3 }})
                    </td>
                    <td v-else class="body" style="background-color: #F4F4F4; line-height: ;">
                        {{ itemm.problem3 }}
                    </td>
                    <!-- 4 -->
                    <td v-if="itemm.attempt4 !== 0 && itemm.problem4 !== '-'" class="body" style="background-color: #EFF9F7; line-height: ;">
                        <div style="height: 16.9px; line-height: 16.9px;"> {{ itemm.problem4 }}</div>
                        <div style="height: 16.9px; line-height: 16.9px;">(-{{ itemm.attempt4 }})</div>
                    </td>
                    <td v-else-if="itemm.attempt4 === 0 && itemm.problem4 !== '-'" class="body" style="background-color: #BFE6DE; line-height: ;">
                        {{ itemm.problem4 }}
                    </td>
                    <td v-else-if="itemm.attempt4 !== 0 && itemm.problem4 === '-'" class="body" style="background-color: #FFECEC; line-height: ;">
                        (-{{ itemm.attempt4 }})
                    </td>
                    <td v-else class="body" style="background-color: #F4F4F4; line-height: ;">
                        {{ itemm.problem4 }}
                    </td>
                    <!-- 5 -->
                    <td v-if="itemm.attempt5 !== 0 && itemm.problem5 !== '-'" class="body" style="background-color: #EFF9F7; line-height: ;">
                        <div style="height: 16.9px; line-height: 16.9px;"> {{ itemm.problem5 }}</div>
                        <div style="height: 16.9px; line-height: 16.9px;">(-{{ itemm.attempt5 }})</div>
                    </td>
                    <td v-else-if="itemm.attempt5 === 0 && itemm.problem5 !== '-'" class="body" style="background-color: #BFE6DE; line-height: ;">
                        {{ itemm.problem5 }}
                    </td>
                    <td v-else-if="itemm.attempt5 !== 0 && itemm.problem5 === '-'" class="body" style="background-color: #FFECEC; line-height: ;">
                        (-{{ itemm.attempt5 }})
                    </td>
                    <td v-else class="body" style="background-color: #F4F4F4; line-height: ;">
                        {{ itemm.problem5 }}
                    </td>
                    <!-- 6 -->
                    <td v-if="itemm.attempt6 !== 0 && itemm.problem6 !== '-'" class="body" style="background-color: #EFF9F7; line-height: ;">
                        <div style="height: 16.9px; line-height: 16.9px;"> {{ itemm.problem6 }}</div>
                        <div style="height: 16.9px; line-height: 16.9px;">(-{{ itemm.attempt6 }})</div>
                    </td>
                    <td v-else-if="itemm.attempt6 === 0 && itemm.problem6 !== '-'" class="body" style="background-color: #BFE6DE; line-height: ;">
                        {{ itemm.problem6 }}
                    </td>
                    <td v-else-if="itemm.attempt6 !== 0 && itemm.problem6 === '-'" class="body" style="background-color: #FFECEC; line-height: ;">
                        (-{{ itemm.attempt6 }})
                    </td>
                    <td v-else class="body" style="background-color: #F4F4F4; line-height: ;">
                        {{ itemm.problem6 }}
                    </td>
                </tr>
            </thead>
            <tbody>
                <tr class="hover" v-for="(item, index) in list" :key="index">
                    <th class="body" scope="row">{{ item.order }}</th>
                    <td class="body" style="color:#25BBA6;">{{ item.user }}</td> 
                    <td class="body">{{ item.accept }}</td>
                    <td class="body" style="border-right: 1px solid lightgrey;">{{ parseInt(item.score / 60) }}</td>
                    <td v-if="item.attempt1 !== 0 && item.problem1 !== '-'" class="body" style="background-color: #EFF9F7; line-height: ;">
                        <div style="height: 16.9px; line-height: 16.9px;"> {{ item.problem1 }}</div>
                        <div style="height: 16.9px; line-height: 16.9px;">(-{{ item.attempt1 }})</div>
                    </td>
                    <td v-else-if="item.attempt1 === 0 && item.problem1 !== '-'" class="body" style="background-color: #BFE6DE; line-height: ;">
                        {{ item.problem1 }}
                    </td>
                    <td v-else-if="item.attempt1 !== 0 && item.problem1 === '-'" class="body" style="background-color: #FFECEC; line-height: ;">
                        (-{{ item.attempt1 }})
                    </td>
                    <td v-else class="body" style="background-color: #F4F4F4; line-height: ;">
                        {{ item.problem1 }}
                    </td>
                    <!-- 2 -->
                    <td v-if="item.attempt2 !== 0 && item.problem2 !== '-'" class="body" style="background-color: #EFF9F7; line-height: ;">
                        <div style="height: 16.9px; line-height: 16.9px;"> {{ item.problem2 }}</div>
                        <div style="height: 16.9px; line-height: 16.9px;">(-{{ item.attempt2 }})</div>
                    </td>
                    <td v-else-if="item.attempt2 === 0 && item.problem2 !== '-'" class="body" style="background-color: #BFE6DE; line-height: ;">
                        {{ item.problem2 }}
                    </td>
                    <td v-else-if="item.attempt2 !== 0 && item.problem2 === '-'" class="body" style="background-color: #FFECEC; line-height: ;">
                        (-{{ item.attempt2 }})
                    </td>
                    <td v-else class="body" style="background-color: #F4F4F4; line-height: ;">
                        {{ item.problem2 }}
                    </td>
                    <!-- 3 -->
                    <td v-if="item.attempt3 !== 0 && item.problem3 !== '-'" class="body" style="background-color: #EFF9F7; line-height: ;">
                        <div style="height: 16.9px; line-height: 16.9px;"> {{ item.problem3 }}</div>
                        <div style="height: 16.9px; line-height: 16.9px;">(-{{ item.attempt3 }})</div>
                    </td>
                    <td v-else-if="item.attempt3 === 0 && item.problem3 !== '-'" class="body" style="background-color: #BFE6DE; line-height: ;">
                        {{ item.problem3 }}
                    </td>
                    <td v-else-if="item.attempt3 !== 0 && item.problem3 === '-'" class="body" style="background-color: #FFECEC; line-height: ;">
                        (-{{ item.attempt3 }})
                    </td>
                    <td v-else class="body" style="background-color: #F4F4F4; line-height: ;">
                        {{ item.problem3 }}
                    </td>
                    <!-- 4 -->
                    <td v-if="item.attempt4 !== 0 && item.problem4 !== '-'" class="body" style="background-color: #EFF9F7; line-height: ;">
                        <div style="height: 16.9px; line-height: 16.9px;"> {{ item.problem4 }}</div>
                        <div style="height: 16.9px; line-height: 16.9px;">(-{{ item.attempt4 }})</div>
                    </td>
                    <td v-else-if="item.attempt4 === 0 && item.problem4 !== '-'" class="body" style="background-color: #BFE6DE; line-height: ;">
                        {{ item.problem4 }}
                    </td>
                    <td v-else-if="item.attempt4 !== 0 && item.problem4 === '-'" class="body" style="background-color: #FFECEC; line-height: ;">
                        (-{{ item.attempt4 }})
                    </td>
                    <td v-else class="body" style="background-color: #F4F4F4; line-height: ;">
                        {{ item.problem4 }}
                    </td>
                    <!-- 5 -->
                    <td v-if="item.attempt5 !== 0 && item.problem5 !== '-'" class="body" style="background-color: #EFF9F7; line-height: ;">
                        <div style="height: 16.9px; line-height: 16.9px;"> {{ item.problem5 }}</div>
                        <div style="height: 16.9px; line-height: 16.9px;">(-{{ item.attempt5 }})</div>
                    </td>
                    <td v-else-if="item.attempt5 === 0 && item.problem5 !== '-'" class="body" style="background-color: #BFE6DE; line-height: ;">
                        {{ item.problem5 }}
                    </td>
                    <td v-else-if="item.attempt5 !== 0 && item.problem5 === '-'" class="body" style="background-color: #FFECEC; line-height: ;">
                        (-{{ item.attempt5 }})
                    </td>
                    <td v-else class="body" style="background-color: #F4F4F4; line-height: ;">
                        {{ item.problem5 }}
                    </td>
                    <!-- 6 -->
                    <td v-if="item.attempt6 !== 0 && item.problem6 !== '-'" class="body" style="background-color: #EFF9F7; line-height: ;">
                        <div style="height: 16.9px; line-height: 16.9px;"> {{ item.problem6 }}</div>
                        <div style="height: 16.9px; line-height: 16.9px;">(-{{ item.attempt6 }})</div>
                    </td>
                    <td v-else-if="item.attempt6 === 0 && item.problem6 !== '-'" class="body" style="background-color: #BFE6DE; line-height: ;">
                        {{ item.problem6 }}
                    </td>
                    <td v-else-if="item.attempt6 !== 0 && item.problem6 === '-'" class="body" style="background-color: #FFECEC; line-height: ;">
                        (-{{ item.attempt6 }})
                    </td>
                    <td v-else class="body" style="background-color: #F4F4F4; line-height: ;">
                        {{ item.problem6 }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import $ from 'jquery'
    export default {
        data() {
            return {
                input: '',
                list:[],

                loading: true,
                user:{},
                itemm:{},
            }
        },
        mounted() {
            if (this.$store.state.me.id !== "") this.readList()
            else {
                const t = setInterval(() => {
                    if (this.$store.state.me.id !== "") {
                        this.readList()
                        clearInterval(t); // 清除定时器
                    }
                }, 100);
            }
        },
        methods: {
            readList() {
                const vue = this
                const store = this.$store
                const route = this.$route

                $.ajax({
                    url: "https://app6132.acapp.acwing.com.cn/jdg/competition/ranklist/",
                    type: "POST",
                    data: ({
                        content: route.params.id,
                        uid: store.state.me.id
                    }),
                    success: function (resp) {
                        console.log(resp);
                        vue.list = resp.Rank
                        vue.user = resp.user
                        vue.itemm = resp.user.userdata
                        vue.loading = false
                    }
                })
            },
            ClickMeToSearch() {
                this.loading = true
                const vue = this
                const store = this.$store
                const route = this.$route

                vue.loading = true
                $.ajax({
                    url: "https://app6132.acapp.acwing.com.cn/jdg/competition/find",
                    type: "POST",
                    data: ({
                        username: vue.input,
                        content: route.params.id
                    }),
                    success(resp) {
                        console.log("resp = ", resp);
                        vue.list = resp.result
                        vue.user = {}
                        vue.itemm = {}
                        vue.loading = false
                    }
                })
            }
        }
    }
</script>

<style scoped>
.body {
    height: 50px;
    line-height: 37.8px;
    text-align: center; 
    font-size:13px; 
    font-weight:400;
}
.hover:hover {
    cursor: pointer;
}
.header {
    height: 50px;
    text-align: center; 
    background-color:#EEEEEE; 
    color: #888888; 
    font-weight:500;
}
</style>